import { CreateDVIRReportParams } from "../TriplePInterface";

export interface DVIRReportPayload {
  data: {
    type: string;
    attributes: {
      template_id: string;
      vehicle_id: string;
      driver_id: string;
      date: string;
      status: string;
    };
  };
}

export const toDVIRReport = (params: CreateDVIRReportParams): DVIRReportPayload => {
  return {
    data: {
      type: "dvir_reports",
      attributes: {
        template_id: params.templateId,
        vehicle_id: params.vehicleId,
        driver_id: params.driverId,
        date: params.date,
        status: "created",
      },
    },
  };
};
